import ReactRailsUJS from 'react_ujs';
import '@babel/polyfill';

ReactRailsUJS.useContext(require.context('components', true));
